import { ReactNode } from 'react';
import { useBannerPositioning } from '../hooks/useBannerPositioning';

interface SidebarWrapperProps {
  isMobileMenuOpen: boolean;
  isSidebarCollapsed: boolean;
  children: ReactNode;
}

export function SidebarWrapper({
  isMobileMenuOpen,
  isSidebarCollapsed,
  children,
}: SidebarWrapperProps) {
  const { sidebarPosition, sidebarSpacerHeight } = useBannerPositioning();

  return (
    <div
      className={`
        fixed left-0 transform bottom-0
        ${sidebarPosition}
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
        ${isSidebarCollapsed ? 'lg:-translate-x-full' : 'lg:translate-x-0'}
        w-[200px]
        transition-transform duration-300 ease-in-out
        bg-theme-light-sidebar dark:bg-theme-dark-sidebar z-50 flex flex-col
      `}
    >
      {/* Spacer for content below fixed logo */}
      <div className={sidebarSpacerHeight}></div>

      {children}
    </div>
  );
}
